import React, { useContext } from 'react';
import { CnForm } from '@/form/cn-form';
import { CnFormItem } from '@/form/cn-form-item';
import { CardItemsStateCtx } from '../../context/card-items';
import { ItemFormat } from '../item-format';
/** 通过表单的样式渲染 */
export const ItemForm = (props) => {
    const { columns } = useContext(CardItemsStateCtx);
    return (React.createElement(CnForm, { hasFooterSubmit: false }, columns.map((column, index) => {
        const { title, dataIndex } = column;
        return (React.createElement(CnFormItem, { title: title || dataIndex, key: dataIndex || index },
            React.createElement(ItemFormat, { ...props, mode: "detail", column: column })));
    })));
};
